export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-black text-foreground-900 text-center mb-8">
          投稿合作
        </h2>
        <div className="bg-background-50 rounded-xl p-6 md:p-10 flex flex-col md:flex-row items-center gap-8 shadow-sm border border-background-200/70">
          <div className="flex-shrink-0 w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-100">
            <i className="ri-mail-send-line text-primary-500 text-3xl md:text-4xl"></i>
          </div>
          <div className="flex-1 text-center md:text-left">
            <h3 className="text-lg md:text-xl font-bold text-foreground-900 mb-2">
              影视投稿与合作咨询
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              如果你有优质影视资源推荐、内容合作意向或意见建议，欢迎通过以下方式联系我们。青柠影视期待与每一位热爱影视的朋友交流。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <a
                href="mailto:contact@qingning.tv"
                className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all duration-200 cursor-pointer whitespace-nowrap no-underline"
              >
                <i className="ri-mail-line"></i>
                发送邮件
              </a>
              <span className="flex items-center gap-2 text-sm text-foreground-500">
                <i className="ri-time-line"></i>
                工作日 24 小时内回复
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}